import { render, staticRenderFns } from "./noLogin.vue?vue&type=template&id=118a6834&scoped=true"
import script from "./noLogin.vue?vue&type=script&lang=js"
export * from "./noLogin.vue?vue&type=script&lang=js"
import style0 from "./noLogin.vue?vue&type=style&index=0&id=118a6834&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a6834",
  null
  
)

export default component.exports